import React from "react";

const CourseContent = ({ course }) => {
  course.levels.forEach(level => {
    level.links.forEach(link => {
      link.read =
        window.localStorage.getItem(link.url) === "true" ? true : false;
    });
  });
  const onCheckboxClick = (event, link) =>
    window.localStorage.setItem(link.url, event.target.checked);
  return (
    <div className="table">
      {course.levels.map(level => (
        <div key={level.id}>
          <h3>{level.name}</h3>
          {level.links.map(link => (
            <div key={link.url} className="table-row">
              <span style={{ width: "40%" }}>
                <input
                  type="checkbox"
                  onClick={e => onCheckboxClick(e, link)}
                  defaultChecked={link.read ? true : false}
                />
                <a href={link.url}>{link.name}</a>
              </span>
            </div>
          ))}
          <br />
        </div>
      ))}
    </div>
  );
};

export default CourseContent;



// WEBPACK FOOTER //
// ./src/components/CourseContent.js